import { useState } from "react";
import api from "./api";
import Card from "./components/Card";
import PartnerCard from "./components/PartnerCard";

function App() {
  const [data, setData] = useState([]);
  const [requested, setRequested] = useState(false);
  function getItems(data) {
    api
      .get(`/api/parceiros?state=${data.estado}&field=${data.ramo}`)
      .then((res) => {
        console.log(res);
        console.log(res.data.data);
        setRequested(true);
        setData(res.data.data);
      });
  }

  return (
    <div>
      <Card getItems={getItems} />
      <div>
        {!data.length && requested ? (
          <div className="text-center">
            Não encontramos nenhum parceiro com esses filtros.
          </div>
        ) : (
          data.map((item, index) => {
            return <PartnerCard item={item} key={index} />;
          })
        )}
      </div>
    </div>
  );
}

export default App;
